<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditBlackListEntryDialog(true)"
      >新增黑名单项</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-download"
      @click="onClickExprotBtn()"
      >导出</el-button
    >

    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        size="mini"
        style="margin-top: 30px"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio label="">备注</el-radio>
            <el-radio label="uid">按UID</el-radio>
            <el-radio label="aid">按AID</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.queryType == ''" label="备注中包含文本：">
          <el-input
            v-model="form.textInRemark"
            clearable
            style="width: 250px"
          ></el-input>
          （遵循<a
            target="_blank"
            href="https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Guide/Regular_expressions#%E7%BC%96%E5%86%99%E4%B8%80%E4%B8%AA%E6%AD%A3%E5%88%99%E8%A1%A8%E8%BE%BE%E5%BC%8F%E7%9A%84%E6%A8%A1%E5%BC%8F"
            style="color: blue"
            >JavaScript正则表达式格式</a
          >）
        </el-form-item>
        <el-form-item
          v-else
          :label="form.queryType == 'uid' ? 'UID：' : 'AID：'"
        >
          <el-input
            v-model="form.queryValue"
            clearable
            style="width: 172px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="blackListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="blackListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 901px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="140" />
      <el-table-column prop="remark" label="备注" align="center" width="250" />
      <el-table-column label="UID" align="center" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.uid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'uid')"
            >
              {{ scope.row.uid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称" align="center" width="90" />
      <el-table-column label="AID" align="center" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.aid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'aid')"
            >
              {{ scope.row.aid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="thirdPartyId"
        label="第三方账号ID"
        align="center"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteBlackListBtn(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改黑名单项”对话框 -->
    <EditBlackListEntryDialog
      v-if="shouldEditBlackListEntryDialogVisible"
      @close="onEditBlackListEntryDialogClosed()"
      :value="valueForEditBlackListEntryDialog"
    ></EditBlackListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("@/util");
import bizutil from "@/bizutil";
const fileDownload = require("js-file-download");
const luxon = require("luxon");
import store from "@/store";

import EditBlackListEntryDialog from "./EditBlackListEntryDialog";

export default {
  data() {
    return {
      shouldEditBlackListEntryDialogVisible: false, // “添加/修改黑名单项”对话框是否应该显示出来
      valueForEditBlackListEntryDialog: null, // 要传递给“添加/修改黑名单项”对话框的数据
      blackListTableData: [], // 黑名单列表里展示的数据
      form: {
        queryType: "",
        queryValue: "",
        textInRemark: "", // 备注里得包含的文本
      },
    };
  },

  created() {
    // 传入uid 进行查询
    let uid = this.$route.query.uid;
    if (uid != null) {
      this.form.queryType = "uid";
      this.form.queryValue = uid;
      this.loadBlackList(0, 10);
      return;
    }

    // 传入aid 进行查询
    let aid = this.$route.query.aid;
    if (aid != null) {
      this.form.queryType = "aid";
      this.form.queryValue = aid;
      this.loadBlackList(0, 10);
      return;
    }
  },

  components: {
    EditBlackListEntryDialog,
  },

  methods: {
    loadMore() {
      this.loadBlackList(this.blackListTableData.length, 20);
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(entry, condition) {
      var query = {};
      switch (condition) {
        case "uid": {
          query = { uid: entry.uid, tab: "playerList" };
          break;
        }
        case "uid": {
          query = { aid: entry.aid, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },

    /**
     * 点击了黑名单项的删除按钮
     * @param {*} entryId
     */
    onClickDeleteBlackListBtn(entryId) {
      this.$confirm("此操作将删除该黑名单项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteBlackListEntry(entryId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 查询黑名单
     */
    async loadBlackList(skip, limit) {
      switch (this.form.queryType) {
        case "": {
          // 全量查

          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.blackListTableData = [];
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/getBlackList`,
              {
                textInRemark: this.form.textInRemark.trim(),
                skip: skip,
                limit: limit,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.entries || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              id: e.id,
              uid: e.uid,
              name: e.name,
              aid: e.aid,
              thirdPartyId: e.thirdPartyId,
              remark: e.remark,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.blackListTableData = this.blackListTableData.concat(list);

          break;
        }
        default: {
          // 根据uid查
          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/getBlackListEntriesByType`,
              {
                byType: this.form.queryType,
                byValue: this.form.queryValue,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.entries || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              id: e.id,
              uid: e.uid,
              name: e.name,
              aid: e.aid,
              thirdPartyId: e.thirdPartyId,
              remark: e.remark,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.blackListTableData = list;

          break;
        }
      }
    },

    /**
     * 删除一个黑名单项
     */
    async deleteBlackListEntry(entryId) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/deleteBlackListEntry`,
          {
            entryId: entryId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        type: "success",
        message: "删除成功!",
      });

      // 重新拉黑名单
      return this.loadBlackList(0, 20);
    },

    /**
     * 打开“添加/修改黑名单项”对话框
     */
    async openEditBlackListEntryDialog(isCreate, oldData) {
      this.shouldEditBlackListEntryDialogVisible = true;
      this.valueForEditBlackListEntryDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改黑名单项”对话框关闭了
     */
    async onEditBlackListEntryDialogClosed() {
      this.shouldEditBlackListEntryDialogVisible = false;
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadBlackList(0, 20);
    },
    /**
     * 点击导出按钮
     */
    async onClickExprotBtn() {
      let resData = (
        await axios.get(
          `${util.getBackendApiBase()}/v1/admin/exportBlackList`,
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
            responseType: "blob",
          }
        )
      ).data;
      fileDownload(
        resData,
        `${store.projectInfo.name}_黑名单_${luxon.DateTime.now().toFormat(
          "yyyyMMddHHmmss"
        )}.xlsx`
      );
    },
  },
};
</script>
